export default [{
    value: '1',
    label: '第一排'
}, {
    value: '2',
    label: '第二排'
}, {
    value: '3',
    label: '第三排'
}, {
    value: '4',
    label: '第四排'
}, {
    value: '5',
    label: '第五排'
}
];



// WEBPACK FOOTER //
// ./src/service/constant/PlatoonLevel.js